import React from "react";
import Container from "../ui/Container";
import Card from "../ui/Card";
import { MousePointerClick, SlidersHorizontal, Wrench, ArrowUpRight } from "lucide-react";
import { BRAND } from "../../lib/config";

function Step({ n, title, body, icon: Icon }) {
  return (
    <Card className="p-7 sm:p-8">
      <div className="flex items-start justify-between gap-6">
        <div>
          <div className="text-xs font-semibold tracking-wider text-white/50">STEP {n}</div>
          <div className="mt-2 text-xl font-semibold text-white">
            {title}<span className="text-cyan-300">.</span>
          </div>
          <p className="mt-3 text-sm leading-6 text-white/65">{body}</p>
        </div>
        <div className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/[0.03]">
          <Icon className="h-5 w-5 text-cyan-300" />
        </div>
      </div>
    </Card>
  );
}

export default function HowItWorks() {
  return (
    <section className="bg-[#070A0F] py-20">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">HOW IT WORKS</div>
          <h2 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl">
            Deploy. Configure. Scale<span className="text-cyan-300">.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-white/70 sm:text-lg">
            No migrations, no plan switching headaches.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <Step
            n="01"
            icon={MousePointerClick}
            title="Choose RAM"
            body="Pick a starting RAM size. CPU will scale proportionally, so the plan stays simple."
          />
          <Step
            n="02"
            icon={Wrench}
            title="Install mods & configs"
            body="Use the panel and file manager. Get help in Discord if you’re tuning a modpack."
          />
          <Step
            n="03"
            icon={SlidersHorizontal}
            title="Upgrade instantly"
            body="Add RAM, storage, or priority when you need it. Upgrades are instant and prorated."
          />
        </div>

        <div className="mt-10 text-center">
          <a href={BRAND.discordUrl} className="text-sm text-white/65 hover:text-white inline-flex items-center gap-1">
            Need help choosing RAM? Ask in Discord <ArrowUpRight className="h-4 w-4 opacity-70" />
          </a>
        </div>
      </Container>
    </section>
  );
}
